import { IAppState } from '../../store';

export const selectAnonymousUserId = (state: IAppState) =>
  state.user.isAuthenticated ? null : state.user.anonymousUserId;
